import React from "react";
import { UpgradeCard } from "./UpgradeCard";
import { UPGRADES } from "../game/constants";

export const UpgradePanel = ({ state, onBuy }) => {
  return (
    <aside className="w-full h-full flex flex-col" data-testid="upgrade-panel">
      <div className="px-4 sm:px-6 pt-5 sm:pt-6 pb-3 sm:pb-4">
        <h2
          className="text-lg sm:text-2xl font-black uppercase tracking-[0.3em] sm:tracking-[0.35em]"
          style={{ color: "#FFD400", fontFamily: "Orbitron, sans-serif" }}
        >
          Upgrades
        </h2>
      </div>
      <div className="flex flex-col gap-2.5 sm:gap-3 px-4 sm:px-6 pb-28 overflow-y-auto">
        {UPGRADES.map((u) => (
          <UpgradeCard
            key={u.id}
            upgrade={u}
            count={state.upgrades[u.id] || 0}
            berries={state.berries}
            onBuy={onBuy}
          />
        ))}
      </div>
    </aside>
  );
};

export default UpgradePanel;
